import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

export const route = "/it/new-ticket-reader/edit/:deviceId";
export const role = "IT";

function EditNewTicketReader() {
    const { deviceId } = useParams();
    const navigate = useNavigate();
    const [deviceData, setDeviceData] = useState(null);
    const [availableNodes, setAvailableNodes] = useState([]);
    const [selectedNodeId, setSelectedNodeId] = useState('');
    const [rideName, setRideName] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [feedback, setFeedback] = useState('');

    useEffect(() => {
        const fetchDeviceDetails = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/new-ticket-readers/${deviceId}`);
                const data = await response.json();
                if (response.ok) {
                    setDeviceData(data);
                    setSelectedNodeId(data.nodeId || '');
                    setRideName(data.rideName || '');
                } else {
                    console.error('Failed to fetch device details');
                }
            } catch (error) {
                console.error('Error fetching device details:', error);
            }
        };

        const fetchNodeOptions = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/gatemaster/nodes`);
                const data = await response.json();
                if (response.ok) {
                    setAvailableNodes(data);
                } else {
                    console.error('Failed to fetch node list');
                }
            } catch (error) {
                console.error('Error fetching node list:', error);
            }
        };

        fetchDeviceDetails();
        fetchNodeOptions();
    }, [deviceId]);

    useEffect(() => {
        const updateRideName = async () => {
            if (selectedNodeId) {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_URL}/gatemaster/nodes/${selectedNodeId}`);
                    const data = await response.json();
                    if (response.ok) {
                        setRideName(data.rideName);
                    }
                } catch (err) {
                    console.error('Error fetching ride name:', err);
                }
            }
        };
        updateRideName();
    }, [selectedNodeId]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setShowModal(true);
    };

    const confirmSubmit = async () => {
        setShowModal(false);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/new-ticket-readers/${deviceId}`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ nodeId: selectedNodeId })
            });

            if (response.ok) {
                await fetch(`${process.env.REACT_APP_API_URL}/new-ticket-readers/${deviceId}/restart-service`);
                navigate('/it/device/list');
            } else {
                alert('Failed to update device');
            }
        } catch (error) {
            console.error('Error updating device:', error);
        }
    };

    if (!deviceData) return <div className="container mt-5">Loading...</div>;

    return (
        <div className="container mt-5">
            <h2>Edit Ticket Reader</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">Node ID</label>
                    <select
                        name="nodeId"
                        value={selectedNodeId}
                        onChange={(e) => setSelectedNodeId(parseInt(e.target.value))}
                        className="form-select"
                    >
                        <option value="">Select a Node</option>
                        {availableNodes.map(node => (
                            <option key={node.value} value={node.value}>
                                {node.label}
                            </option>
                        ))}
                    </select>
                </div>
                <button type="submit" className="btn btn-primary">Update Node</button>
            </form>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Update</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to change this reader's Node ID? This will restart the reader's service. <br /><br />
                    <strong>This should not be done while the reader is out on the pier.</strong>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                    <Button variant="danger" onClick={confirmSubmit}>Yes, Restart and Update</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default EditNewTicketReader;